import { ChangeDetectorRef, OnDestroy, Pipe, PipeTransform } from '@angular/core';
import { Subscription } from 'rxjs';

import { LearningHubLanguage } from '../definitions/learning-hub.models';
import { LearningHubI18nService } from '../services/learning-hub-i18n.service';

/**
 * `{{ 'learningHub.home.title' | lhTranslate: lang }}`: like the ngx-translate pipe, but in the language of the
 * Learning Hub content (see LearningHubI18nService).
 */
@Pipe({ name: 'lhTranslate', pure: false })
export class LearningHubTranslatePipe implements PipeTransform, OnDestroy {
  private _cacheKey: string;
  private _value = '';
  private readonly SUBSCRIPTION: Subscription;

  constructor(private readonly _i18n: LearningHubI18nService, private readonly _changeDetector: ChangeDetectorRef) {
    this.SUBSCRIPTION = this._i18n.changes$.subscribe(() => {
      this._cacheKey = null;
      this._changeDetector.markForCheck();
    });
  }

  transform(key: string, lang?: LearningHubLanguage | null, params?: Record<string, unknown>): string {
    if (!key) {
      return '';
    }
    const cacheKey = `${lang}|${key}|${params ? JSON.stringify(params) : ''}`;
    if (cacheKey !== this._cacheKey) {
      // Memoized until the inputs change or new translations arrive (changes$ resets it).
      this._value = this._i18n.instant(key, lang, params);
      this._cacheKey = cacheKey;
    }
    return this._value;
  }

  ngOnDestroy(): void {
    this.SUBSCRIPTION.unsubscribe();
  }
}
